import { SVGProps } from 'react';
import literals from '~theme/literals';

function Ellipse(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={80} cy={80} r={76} stroke="#F4F4F5" strokeWidth={8} />
      <path
        d="M78.676 155.989a75.998 75.998 0 0 1-64.756-38.447"
        stroke={literals.surface.primary}
        strokeWidth={8}
        strokeLinecap="round"
      />
    </svg>
  );
}

Ellipse.defaultProps = {
  role: 'graphics-document',
};

export default Ellipse;
